import { AxiosRequestConfig } from 'axios';
import { pickBy } from 'lodash';
import config from 'src/config';
import Http from 'src/helpers/httpClient';
import { IdOrIdName } from 'src/types/common';

import { FetchMyDegreeRequestPayload, HttpFetchMyDegreeApiResponse } from './types/degreeType';

import { getAuthorizationHeader } from '@helpers/auth';
import { clientApi } from '@infrastructures/adapter/http/httpClient';

const END_POINT = 'v1/degree';

export const DEGREE_END_POINT = {
  COURSES: (idName: IdOrIdName) => `${END_POINT}/${idName}/degree-course`,
};

export default {
  fetchDegreeCourses(idName: IdOrIdName, params: Record<string, unknown>) {
    const apiUrl = `${config.API_DOMAIN}/${DEGREE_END_POINT.COURSES(idName)}`;

    return Http.get(apiUrl, { isPublic: true, params: pickBy(params, (v) => !!v) });
  },
};

export const degreeAPI = {
  async getMyDegree(payload: FetchMyDegreeRequestPayload): Promise<HttpFetchMyDegreeApiResponse> {
    const url = '/v2/degrees/my-degrees';
    const options: AxiosRequestConfig = {
      headers: getAuthorizationHeader(),
      params: {
        universityId: payload.universityId,
      },
    };

    return clientApi
      .get(url, options)
      .then((res) => res.data)
      .catch((error) => error);
  },
};
